import type React from "react";
import {
  ScrollArea as ShadcnScrollArea,
  ScrollBar as ShadcnScrollBar,
} from "src/shadcn/components/scroll-area";

const ScrollArea = (props: React.ComponentProps<typeof ShadcnScrollArea>) => (
  <ShadcnScrollArea {...props} />
);

const ScrollBar = (props: React.ComponentProps<typeof ShadcnScrollBar>) => (
  <ShadcnScrollBar {...props} />
);

export { ScrollArea, ScrollBar };
